var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "d-flex flex-column" },
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-icon", { staticClass: "pr-2", attrs: { large: "" } }, [
                _vm._v("mdi-calendar-today"),
              ]),
              _c("h3", [_vm._v(_vm._s(_vm.$t("absenceAdministration")))]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-text",
        { staticClass: "flex-grow-1 overflow-auto" },
        [
          _c("v-data-table", {
            staticStyle: { "min-height": "240px" },
            attrs: {
              items: _vm.absences,
              "hide-default-header": "",
              headers: _vm.absencesTableHeader,
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.Farbcode",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-icon",
                      {
                        style: "color: " + item.Farbcode + ";",
                        attrs: { width: "20%" },
                      },
                      [_vm._v("mdi-checkbox-blank-circle")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c(
            "v-row",
            { attrs: { justify: "end", "no-gutters": "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mr-2 mb-2",
                  staticStyle: { color: "white" },
                  attrs: { rounded: "", color: "#990000" },
                  on: {
                    click: function ($event) {
                      _vm.ShowAbsenceAdministration = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("manage")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.ShowAbsenceAdministration
        ? _c("AbsenceAdministration", {
            on: {
              close: function ($event) {
                _vm.ShowAbsenceAdministration = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }